import api from "./api";

export const skillsService = {
  getAll: async (
    page = 1,
    limit = 10,
    search = "",
    sortBy = "name",
    sortOrder = "asc",
  ) => {
    const response = await api.get("/api/admin/skills", {
      params: { page, limit, search, sortBy, sortOrder },
    });
    return response.data;
  },

  getById: async (id) => {
    const response = await api.get(`/api/admin/skills/${id}`);
    return response.data;
  },

  create: async (data) => {
    const response = await api.post("/api/admin/skills", data);
    return response.data;
  },

  update: async (id, data) => {
    const response = await api.patch(`/api/admin/skills/${id}`, data);
    return response.data;
  },

  delete: async (id) => {
    const response = await api.delete(`/api/admin/skills/${id}`);
    return response.data;
  },
};
